import React from 'react';
import '../../filterablePeripheralList/peripheralList/peripheralRow/peripheralRow.css'

class KSxRow extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            rowCol: this.props.rowCol,
            num: this.props.rowCol[this.props.index],
            maxNum: 19
        }
        this.handleNumChange = this.handleNumChange.bind(this);
    }

    handleNumChange(evt) {
        let cur_num = parseInt(evt.target.value);
        if (cur_num > this.state.maxNum) {
            cur_num = this.state.maxNum;
        }
        this.setState({num: cur_num});
        this.props.rowCol[this.props.index] = cur_num;
    }

    render() {

        let pinNameStyle = {
            display: "block",
            fontSize: "0.8em",
            width: "3em",
        }

        let inputNumStyle = {
            marginLeft: "1em",
            fontSize: "0.8em",
            width: "5em",
        }

        return (
            <tr>
                <td>
                    <div className="row-peripheral">
                        <span style={pinNameStyle}>
                            {this.props.name.toUpperCase() + this.props.pinName}
                        </span>

                        <input type="number" 
                            min={0}
                            max={this.state.maxNum /* TODO: make this a const located elsewhere? */} 
                            style={inputNumStyle} 
                            placeholder={this.props.name === "ksi" ? "Row #" : "Col #"}
                            value={this.state.num !== -1 ? this.state.num : ''}
                            onChange={this.handleNumChange}/>
                    </div>
                </td>
            </tr>
        );
    }
}

export default KSxRow;
